import React, { Fragment } from "react";
import { PublicRoutes } from "./PublicRoutes";
import { PrivateRoutes } from "./PrivateRoutes";

function AppRoutes() {
    return (
        <Fragment>
            {/* Routes that do not require authentication */}
            <PublicRoutes />

            {/* Routes protected by authentication */}
            <PrivateRoutes />

            {/* You could add a "NotFound" or 404 route here if desired */}
        </Fragment>
    );
}

export default AppRoutes;
